import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";


export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: baseApiQuery,
    tagTypes: ["products"],
    // keepUnusedDataFor: 86400,
    endpoints: (builder) => ({
        getProducts: builder.query({
            query: () => ({
                url: 'wh/products/list/',
                method: "GET",
            }),
            providesTags: ['products'],
            // pollingInterval: 86400000,
            // transformResponse: (response) => {
            //     return Array.isArray(response) ? response : [];
            // },
        }),
        quoteEnquiry: builder.mutation({
            query: (user) => ({
                url: 'wh/quote/inquiry/',
                method: 'POST',
                body: user,
            })
        }),
    })
})

export const { useGetProductsQuery, useQuoteEnquiryMutation } = productApi